module.exports = __webpack_public_path__ + "static/media/filter.d18842be.svg";